module.exports = __webpack_public_path__ + "media/images/menu/tucana-2cc199ec799b984a8c39086f4a3ec439.jpg";